<ng-template #thModal let-modal>
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header d-flex justify-content-between align-items-center">
        <div>
          {{ title }}
        </div>
        <div class="justify-content-end default-pointer" (click)="modal.close(false)" title="Close" aria-label="Close" id="closeModalBtn">
          <svg xmlns="http://www.w3.org/2000/svg" width="15px" height="15px" viewBox="0 0 384 512">
            <!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.-->
            <path
              fill="var(--grey-text-color)"
              d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"
            />
          </svg>
        </div>
      </div>
      <div class="modal-body custom-modal-body">
        <div class="scrollable-content">
          <div class="content-wrapper">
            <pre *ngIf="selectedConcept"><code>{{ modalContent }}</code></pre>
            <span *ngIf="!selectedConcept">
              {{ modalContent }}
            </span>
          </div>
        </div>
      </div>
      <div class="modal-footer"></div>
    </div>
  </div>
</ng-template>
